<template>
  <v-row>
    <v-col>
      <v-autocomplete
        :rules="[required]"
        :loading="!locations.length"
        :items="locations"
        item-value="location_guid"
        item-text="name"
        outlined
        label="Kategorier"
        v-model="model"
        multiple
        :disabled="readonly"
      >
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { sync } from 'vuex-pathify'

export default {
  name: 'OdocLocationsInput',

  props: {
    locations: Array,
    readonly: Boolean
  },

  data() {
    return { required }
  },

  computed: {
    model: sync('odoc/model@locations')
  }
}
</script>
